export const obavijest_r_vijecu= {
    templateId: 75,
    category: 17,
    templateTitle: 'Obavijest (kvartalna) radničkom vijeću/sindikalnom povjereniku prema Zakonu o radu',
    templateDescription: `<p>Poslodavac je dužan najmanje svaka tri mjeseca obavijestiti radničko vijeće/sindikalnog povjerenika o određenim važnim pitanjima propisanim Zakonom o radu.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p><strong>Za početak je važno reći da ukoliko kod poslodavca nije utemeljeno radničko vijeće, no postoji imenovan sindikalni povjerenik, da isti preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu.</strong> </p>
    <p>U tom smislu, sve što se navodi u nastavku u odnosu na radničko vijeće, u cijelosti se primjenjuje i na sindikalnog povjernika koji je imenovan kod poslodavca.</p>
    <p>Prema Zakonu o radu, poslodavac je dužan najmanje svaka tri mjeseca obavijestiti radničko vijeće o:</p>
    <p> 1) stanju, rezultatima poslovanja te organizaciji rada,</p>
    <p> 2) očekivanom razvoju poslovnih aktivnosti i njihovu utjecaju na gospodarski i socijalni položaj radnika,</p>
    <p> 3) prijenosu poduzeća, dijela poduzeća, gospodarske djelatnosti ili dijela gospodarske djelatnosti, kao i ugovora o radu radnika na novog poslodavca te o utjecaju takvog prijenosa na radnike koji su prijenosom obuhvaćeni,</p>
    <p> 4) mjerama u vezi sa zaštitom zdravlja i sigurnosti na radu, </p>
    <p> 5) uvođenju nove tehnologije te promjena u organizaciji i načinu rada, </p>
    <p> 6) planu godišnjih odmora, </p>
    <p> 7) rasporedu radnog vremena, </p>
    <p> 8) noćnom radu, </p>
    <p> 9) naknadama za izume i tehničko unapređenje,</p>
    <p> 9) kolektivnom višku radnika prema Zakonu o radu te sve druge odluke za koje je Zakonom o radu ili kolektivnim ugovorom propisano sudjelovanje radničkog vijeća u njihovu donošenju.</p>
    <p> O navedenim pitanjima, poslodavac je dužan obavijestiti radničko vijeće u vrijeme, u sadržaju i na način koji omogućuju članovima radničkog vijeća da izvrše procjenu mogućeg utjecaja te da se pripreme za savjetovanje s poslodavcem.</p>
    <br>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neobavješćivanje radničkog vijeća/sindikalnog povjerenika na vrijeme o pitanjima koje određuje Zakon o radu.</strong></p>
    <p>Pojašnjenje: navedeno postupanje predstavlja prekršaj sukladno Zakonu o radu.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "R. vijeće / Sindikalni povj.",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        help: 'Ime i prezime predsjednika radničkog vijeća ili sindikalnog povjerenika',
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
  
    title: '\r\n\r\nPREDMET: Obavijest Poslodavca prema čl. 149. Zakona o radu',
    noArticleNumbers: true,
    suffix: ' ',

    articles: [
      {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'Poštovani,\r\n\r\nna temelju članka 149. Zakona o radu obavještavamo Vas o: \r\n\r\n1. stanju, rezultatima poslovanja i organizaciji rada za prošlo kvartalno razdoblje, \r\n2. očekivanom razvoju poslovnih aktivnosti i njihovom utjecaju na gospodarski i socijalni položaj radnika,\r\n3. kretanju i promjenama u plaćama,\r\n4. broju radnika i vrsti zapošljavanja, strukturi zaposlenosti te razvoju i politici zapošljavanja,\r\n5. zaštiti zdravlja i sigurnosti na radu i mjerama za poboljšanje uvjeta rada,\r\n6. uvođenju nove tehnologije,\r\n7. radnom vremenu (noćni rad) i planu korištenja godišnjih odmora,\r\n8. drugim pitanjima osobito važnim za gospodarski i socijalni položaj radnika.',
                value: '',
            },
        ],
        value: '',
    },
 {
        title: "STANJE, REZULTATI POSLOVANJA I ORGANIZACIJA RADA ZA PROŠLO KVARTALNO RAZDOBLJE",
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "text", content: "Stanje, rezultati poslovanja i organizaciji rada za prošlo kvartalno razdoblje bili su sljedeći:" },
              { type: "textarea", value: "", required: true,},  
            ],
          }
        ]
      },
      {
        title: "OČEKIVANI RAZVOJ POSLOVNIH AKTIVNOSTI I NJIHOVOM UTJECAJU NA GOSPODARSKI I SOCIJALNI POLOŽAJ RADNIKA",
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "text", content: "U idućem razdoblju planiramo poduzeti sljedeće aktivnosti:" },
              { type: "textarea", value: "", required: true,},  
              { type: "text", content: "\r\nOčekivani utjecaj navedenih aktivnosti će biti sljedeći:" },
              { type: "textarea", value: "", required: true,},  
            ],
          }
        ]
      },
      {
        title: "KRETANJE I PROMJENE U PLAĆAMA",
        mandatory: false,
        dummy: true,
        exampleContent: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "textarea", value: "Što se tiče kretanja i promjenama u plaćama, iste se kao i porezi i doprinosi uredno i na vrijeme isplaćuju.", required: true,},  
            ],
          }
        ]
      },
      {
        title: "BROJ RADNIKA I VRSTA ZAPOŠLJAVANJA, STRUKTURA ZAPOSLENOSTI, RAZVOJU I POLITIKA ZAPOŠLJAVANJA",
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "text", content: "Broja radnika i vrsta zapošljavanja bili su sljedeći:" },
              { type: "textarea", value: "", required: true,},  
              { type: "text", content: "\r\nStruktura zaposlenosti bila je sljedeća:" },
              { type: "textarea", value: "", required: true,},  
              { type: "text", content: "\r\nPoduzete su sljedeće aktivnosti u razvoju i politici zapošljavanja:" },
              { type: "textarea", value: "", required: true,},  
            ],
          }
        ]
      },
      {
        title: "ZAŠTITA ZDRAVLJA I SIGURNOSTI NA RADU I MJERAMA ZA POBOLJŠANJE UVJETA RADA",
        mandatory: false,
        dummy: true,
        exampleContent: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "textarea", value: "Zaštita i sigurnost na radu provodi se kroz Službu zaštite na radu. Redovito se prema planu vode evidencije radnika koji podliježu obaveznim liječničkim pregledima kao i sami liječnički pregledi, kao i evidencije o internim osposobljavanjima iz područja ZNR i PPZ, o ispitivanju strojeva, o nabavljenoj HTZ opremi. Inspekcijskih nadzora u području rada i zaštite na radu u razdoblju na koje se odnosi ova Obavijest, nije bilo.", required: true,},  
            ],
          }
        ]
      },
      {
        title: "UVOĐENJE NOVE TEHNOLOGIJE",
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "textarea", value: "U prethodnom razdoblju nije bilo uvođenja novih tehnologija u proces rada.", required: true,},  
            ],
          }
        ]
      },
      {
        title: "RADNO VRIJEME (NOĆNI RAD) I PLAN KORIŠTENJA GODIŠNJIH ODMORA",
        mandatory: false,
        dummy: true,
        exampleContent: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "textarea", value: "Ovisno o potrebama posla, vremenskim uvjetima i nizu drugih okolnosti koje je ponekad vrlo teško predvidjeti, kao i njihovo trajanje, eventualni prekovremeni rad reguliran je u skladu s postojećim Zakonom o radu.\r\nNoćnog rada nije bilo. \r\nRadnici koriste godišnji odmor prema planu korištenja godišnjeg odmora.", required: true,},  
            ],
          }
        ]
      },
      {
        title: "",
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                {type: 'text', content: 'Ova obavijest se odnosi na razdoblje od'},
                {type: 'input', value: '', required: true,},
                {type: 'text', content: '​do'},
                {type: 'input', value: '', required: true,},
                {type: 'text', content: '​godine.'},
            ],
          }
        ]
      },
      {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'S poštovanjem.',
                value: '',
            },
        ],
        value: '',
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
  },
  {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Sindikalnom povjerniku / radničkom vijeću Poslodavca \r\n2) Kadrovska služba',
          help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
],
};













// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/75_obavijest_r_vijecu.ts